// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const getFileDownloadLinkApi = ({fileId, fileVersionId}) =>
  api().get(`/files/${fileId}/versions/${fileVersionId}/content`);

export default getFileDownloadLinkApi;
